import React from "react"
import Style from "./NutritionCalculatorSearchResultStyle.module.styl"
import Image from "../../../../../assets/images/nutrition-calculator-icon.svg"
import translate from "../../../../../translation/translator"
import keys from "../../../../../translation/keys"

const NutritionCalculatorSearchResult = ({
  foodResults,
  handleGetMeal,
  locale,
}) => {
  return (
    <React.Fragment>
      {" "}
      {foodResults ? (
        <div className={Style.food_results_holder}>
          {foodResults.map((foodResult, index) => (
            <div
              className={Style.food_result}
              key={index}
              role="button"
              tabIndex={index}
              onKeyDown={() => handleGetMeal(foodResult)}
              onClick={() => handleGetMeal(foodResult)}
            >
              <div className={Style.description_holder}>
                <p className={Style.food_name}>{foodResult.description}</p>
                <div className={Style.circle}>
                  <p>
                    {foodResult.labelNutrients.fat
                      ? foodResult.labelNutrients.fat.value.toFixed(2)
                      : "0"}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className={Style.food_analysis_holder}>
          <p>{translate(keys.NUTRITION_TEXT, locale)}</p>
          <img src={Image} alt="icon" />
        </div>
      )}
    </React.Fragment>
  )
}

export default NutritionCalculatorSearchResult
